import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function Aviator26FreeBetsBonanzaPromoFun(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <InformationWrapper>
                <TitleConatiner>
                    <h1>Aviator 26 Free Bets - Fly Higher, Win Bigger</h1>
                    <p>Make <strong>one qualifying deposit</strong> and unlock <strong>up to 26 free bets</strong> on Aviator. Chase <strong>high multipliers</strong> <br /> and enjoy <strong>extra chances to win every day</strong>.</p>
                    <Link to='/instant-games/spribe/aviator'>Play Now</Link>
                </TitleConatiner>
                <Container>
                    <LeftCardWrapper>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.Aviator26FreeBetsBonanzaIconOne}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Make a <strong>single deposit of ₹5,000 or more</strong> in a day</p>
                        </LeftCard>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.Aviator26FreeBetsBonanzaIconTwo}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Launch and play Aviator</strong></p>
                        </LeftCard>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.Aviator26FreeBetsBonanzaIconThree}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Receive up to 26 free bets</strong></p>
                        </LeftCard>
                    </LeftCardWrapper>
                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.Aviator26FreeBetsBonanzaImageOne}`}
                            alt="Aviator26FBB"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                </Container>

                <Container>
                    <TermsImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.Aviator26FreeBetsBonanzaTermsImage}`}
                            alt="Aviator26FBB"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </TermsImageWrapper>
                    <RightCradWrapper>
                        <RightCard><p>Valid from <strong>01 Jan 2026 to 28 Feb 2026</strong></p></RightCard>
                        <RightCard><p><strong>Applicable on Aviator game only</strong></p></RightCard>
                        <RightCard><p><strong>Free bet value up to ₹50 per bet</strong></p></RightCard>
                        <RightCard><p><strong>Maximum benefit per player per day: ₹1,300</strong></p></RightCard>
                        <RightCard><p><strong>Claimable up to 3 times per week per player</strong></p></RightCard>
                        <RightCard><p>Free bets are credited as <strong>non-withdrawable bonuses</strong></p></RightCard>
                        <RightCard><p><strong>Only winnings from free bets are credited to the wallet</strong> <br /> (Example: Total free bets = 100 | Total winnings = 200 → <strong>Wallet credit = 100</strong>)</p></RightCard>
                        <RightCard><p><strong>Bonus winnings are subject to wagering requirements</strong></p></RightCard>
                        <RightCard><p><strong>Estimated total promotion pool: ₹1,30,00,000</strong></p></RightCard>
                        <RightCard><p><strong>Fun88 reserves the right</strong> to revise bonus caps or mechanics at any time</p></RightCard>
                        <RightCard><p><strong>General Fun88 terms & conditions apply</strong></p></RightCard>
                    </RightCradWrapper>
                </Container>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(Aviator26FreeBetsBonanzaPromoFun));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1rem 0 5rem 0;
    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #444;
    background-color: #EBEBEB;
    text-transform: capitalize;
`;

const TitleConatiner = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    background-color: #fff;
    padding: 1.5em;
    border-radius: 8px;

    h1 {
        color: #F00;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        margin: 0;
    }

    p {
        color: #444;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-transform: capitalize;
        margin: 0;
    }

    a {
        background: linear-gradient(0deg, #F00 0%, #F00 100%), linear-gradient(180deg, #7ABDD8 0%, #006993 101.45%);
        padding: 0.75rem 3rem;
        border: 2px solid #FFFFFF;
        border-radius: 15px;
        box-shadow: 0 0 10px #F00;
        color: #FFF;
        text-align: center;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 27px;
        text-transform: uppercase;
        cursor: pointer;
    }
`;

const Container = styled.div`
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    background-color: #fff;
    padding: 1.5em;
    border-radius: 8px;
`;

const LeftCardWrapper = styled.div`
    flex: 0 0 40%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-direction: column;
    gap: 1rem;
`;

const ImageWrapper = styled.div`
    flex: 1;
    display: flex;
    text-align: left;
    justify-content: center;
    align-items: flex-start;
    
    img {
        width: 75%;
        align-self: flex-start;
    }
`;

const LeftCard = styled.div`
    width: 85%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    border-radius: 9.556px;
    border: 1px solid #B6B6B6;
    border-radius: 10px;
    background: linear-gradient(0deg, #EBEBEB 0%, #EBEBEB 100%), rgba(255, 255, 255, 0.10);
    backdrop-filter: blur(7.5px);
    padding: 1.5rem 3.5rem 1.5rem 2.5rem;

    img {
        width: 50px;
    }

    p {
        width: 85%;
        color: #444;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
        text-transform: capitalize;
        margin: 0;
    }
`;

const TermsImageWrapper = styled.div`
    flex: 0 0 45%;
    display: flex;
    text-align: right;
    justify-content: center;
    align-items: flex-start;

    img {
        width: 65%;
        align-self: flex-end;
    }
`;

const RightCradWrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
`;

const RightCard = styled.div`
    width: 80%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    background: #EBEBEB;
    backdrop-filter: blur(7.5px);
    padding: 10px 25px;

    p {
        color: #444;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        margin: 0;
    }
`;